<div class="collapsible-toggle-box-group" [attr.data-automation-id]="automationId + '-container'" id="toggleBoxId">
    <div *ngFor="let toggle of toggleItems" class="toggle-box">
        <res-custom-checkbox [hidden]="toggle.isCollapsed" [automationId]="automationId + toggle.automationId"
            [isToggleBoxGroupItem]="true" [(ngModel)]="toggle.isChecked" [content]="toggle.label"
            [isDisabled]="toggle.isDisabled" [title]="toggle.tooltip" [isToggleBox]="true"
            [isSkeuomorphic]="isSkeuomorphic" (ngModelChange)="onModelChange(toggle)"></res-custom-checkbox>
    </div>
    <div [hidden]="!dropdownToggleButtonVisible" role="button" (click)="onContextMenu($event)" [title]="buttonTooltip"
        class="expand-button" [attr.data-automation-id]="automationId + '-expand-button'"
        [ngClass]="[hasCheckedToggles() ? 'blue-background' : '']">
        <img [src]="hasCheckedToggles()? 'assets/images/ellipsis_blue.png' : 'assets/images/ellipsis_black.png'"
            class="expand-image" [ngClass]="[hasCheckedToggles() ? 'expand-image-blue' : '']">
    </div>
</div>

<res-context-menu #collapsedContextMenu [hasDeselectAll]="hasDeselectAll" [openMenuOnLeft]="openMenuOnLeft"
    [removeLeftMargin]="removeLeftMargin" [isSkeuomorphic]="isSkeuomorphic" [isAdvancedSearch]="isAdvancedSearch" [labelPaddingLeft]="labelPaddingLeft"
    [labelPaddingRight]="labelPaddingRight" [onModelChangeEvent]="onModelChange.bind(this)"
    [deselectAllEvent]="deselectAll.bind(this)">
</res-context-menu>